import { GraphQLError } from "graphql";
import { Button, Text } from "north.js";
import React, { useState } from "react";

import { Modal, errorToast, successToast } from "src/shared/components";
import { EVENT_ID } from "src/shared/constants/event";
import { useEventContext } from "src/shared/contexts";

import { useEnterHardwareLotteryMutation } from "../../graphql/enterHardwareLottery.generated";
import { THardwareSku } from "../../shared/hardwareModels";

interface LotteryEntryModalProps {
  isOpen: boolean;
  onClose: () => void;
  skuCode: string;
  hardwareSkus: THardwareSku[];
}

const LotteryEntryModal: React.FC<LotteryEntryModalProps> = ({
  isOpen,
  onClose,
  skuCode,
  hardwareSkus,
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { hardware } = useEventContext();
  const takingRequests = hardware.takingRequests;
  const [enterHardwareLottery] = useEnterHardwareLotteryMutation();

  const item = hardwareSkus.find((sku) => sku.code === skuCode);

  const handleSubmit = async () => {
    if (!takingRequests) return;
    try {
      setIsSubmitting(true);
      await enterHardwareLottery({
        variables: {
          sku_code: skuCode,
          event_id: EVENT_ID,
        },
      });
      successToast(
        "Successfully requested the special item! In order to be selected for a special item after requesting it, you’ll need to present a short, live pitch in the QNX Makerspace about what you’re thinking of building with it! Pitches will begin at 1:00 AM on Saturday in the QNX Makerspace"
      );
      onClose();
    } catch (e) {
      errorToast((e as GraphQLError)?.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={`Request Special Item - ${item?.name || "Item"}`}
      width="500px"
    >
      <div>
        <Text type="body1" style={{ marginBottom: "16px" }}>
          In order to be selected for a special item, you’ll need to present a
          short, live pitch in the QNX Makerspace about what you’re thinking of
          building with it! Your pitch can be as simple or creative as you’d
          like, but we’ll be awarding points for originality in how you present{" "}
          <span role="img" aria-label="eyes">
            👀
          </span>
        </Text>

        <br />

        <Text type="body1" style={{ marginBottom: "16px" }}>
          Pitches will begin at <b>1:00 AM on Saturday</b> in the Makerspace,
          with requests closing at <b>12:50 AM</b>.
        </Text>

        <br />
        <br />

        <div
          style={{ display: "flex", gap: "12px", justifyContent: "flex-end" }}
        >
          <Button color="secondary" onClick={onClose} disabled={isSubmitting}>
            Cancel
          </Button>
          <Button
            color="primary"
            onClick={handleSubmit}
            disabled={isSubmitting || !takingRequests}
          >
            {isSubmitting ? "Requesting..." : "Request Item"}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default LotteryEntryModal;
